import { Theme } from '@withjoy/joykit';
import type { Property } from 'csstype';

export type Intent = 'primary' | 'secondary';
export type Flavor = 'brand' | 'grey' | 'error' | 'white';
export type buttonType = 'submit';

type ButtonProperties = {
  color: Property.Color;
  backgroundColor: Property.BackgroundColor | undefined;
  borderColor: Property.BorderColor;
};

type ButtonTypeConfig = {
  default: ButtonProperties;
  hover: ButtonProperties;
  active: ButtonProperties;
};

type ButtonUseConfig = {
  [k in Flavor]: ButtonTypeConfig;
};

type ButtonIntentConfig = {
  primary: ButtonUseConfig;
  secondary: Omit<ButtonUseConfig, 'error'>;
};

interface ButtonColorsArguments {
  theme: Theme;
}

// TODO: ensure all uses of `buttonColors` => `buttonColors(props)`
const buttonColors = ({ theme }: ButtonColorsArguments): ButtonIntentConfig => {
  return {
    primary: {
      brand: {
        default: {
          color: theme.colors.white,
          backgroundColor: theme.colors.fillDark,
          borderColor: theme.colors.transparent
        },
        hover: {
          color: theme.colors.white,
          backgroundColor: theme.colors.fillDarkHover,
          borderColor: theme.colors.transparent
        },
        active: {
          color: theme.colors.white,
          backgroundColor: theme.colors.fillDarkActive,
          borderColor: theme.colors.transparent
        }
      },
      grey: {
        default: {
          color: theme.colors.white,
          backgroundColor: theme.colors.mono13,
          borderColor: theme.colors.transparent
        },
        hover: {
          color: theme.colors.white,
          backgroundColor: theme.colors.mono10,
          borderColor: theme.colors.transparent
        },
        active: {
          color: theme.colors.white,
          backgroundColor: theme.colors.mono11,
          borderColor: theme.colors.transparent
        }
      },
      error: {
        default: {
          color: theme.colors.white,
          backgroundColor: theme.colors.negative6,
          borderColor: theme.colors.transparent
        },
        hover: {
          color: theme.colors.white,
          backgroundColor: theme.colors.negative5,
          borderColor: theme.colors.transparent
        },
        active: {
          color: theme.colors.white,
          backgroundColor: theme.colors.negative7,
          borderColor: theme.colors.transparent
        }
      },
      white: {
        default: {
          color: theme.colors.stroke,
          backgroundColor: theme.colors.white,
          borderColor: theme.colors.transparent
        },
        hover: {
          color: theme.colors.stroke,
          backgroundColor: theme.colors.white,
          borderColor: theme.colors.transparent
        },
        active: {
          color: theme.colors.stroke,
          backgroundColor: theme.colors.white,
          borderColor: theme.colors.transparent
        }
      }
    },
    secondary: {
      brand: {
        default: {
          color: theme.colors.stroke,
          backgroundColor: theme.colors.transparent,
          borderColor: theme.colors.stroke
        },
        hover: {
          color: theme.colors.stroke,
          backgroundColor: theme.colors.brandPurple1, // QUESTION: ??
          borderColor: theme.colors.stroke
        },
        active: {
          color: theme.colors.stroke,
          backgroundColor: theme.colors.brandPurple2, // QUESTION: ??
          borderColor: theme.colors.stroke
        }
      },
      // don't define background as transparent colors incase the button is fixed and background color is defined by an extension of the class
      grey: {
        default: {
          color: theme.colors.mono13,
          backgroundColor: 'inherit', // QUESTION: inherit should work, no?
          borderColor: theme.colors.mono3
        },
        hover: {
          color: theme.colors.white,
          backgroundColor: 'inherit', // QUESTION: inherit should work, no?
          borderColor: theme.colors.mono5
        },
        active: {
          color: theme.colors.white,
          backgroundColor: 'inherit', // QUESTION: inherit should work, no?
          borderColor: theme.colors.mono10
        }
      },
      white: {
        default: {
          color: theme.colors.stroke,
          backgroundColor: theme.colors.white,
          borderColor: theme.colors.transparent
        },
        hover: {
          color: theme.colors.stroke,
          backgroundColor: theme.colors.white,
          borderColor: theme.colors.transparent
        },
        active: {
          color: theme.colors.stroke,
          backgroundColor: theme.colors.white,
          borderColor: theme.colors.transparent
        }
      }
    }
  };
};

export { buttonColors };
